import { RedoShopifyDeliveryMethodType } from "@redotech/redo-fulfillment-common/fulfillment-delivery-method-type";
import { FulfillmentGroupStatus } from "@redotech/redo-fulfillment-common/fulfillment-group-status";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export function groupDataPickupInRedoButNotInShopify(
  group: FulfillmentGroupData,
) {
  return (
    group.status === FulfillmentGroupStatus.ReadyForPickup &&
    group.fulfillmentOrderIds.some((externalId) => {
      const deliveryMethod =
        group.fulfillmentOrderToDeliveryMethod[externalId]?.kind;
      return (
        deliveryMethod === RedoShopifyDeliveryMethodType.Shipping ||
        deliveryMethod === RedoShopifyDeliveryMethodType.Local ||
        deliveryMethod === RedoShopifyDeliveryMethodType.Freight
      );
    })
  );
}
